import axios from 'axios';

import { getUrls } from '../../../utils/url';

const { api } = getUrls();

export const registerSecondaryWebsocket = async (meetingId, connectionId, userUuid) => {
    axios.post(`${api}/meeting/${meetingId}/v1_register_secondary_websocket`, {
        data: {
            user_uuid: userUuid,
            type: 'video',
            connection_id: connectionId
        }
    });
};
